import authHeader from "./auth-header";
import axiosInstance from "./instance";

class AuthService {
  login(user) {
    return axiosInstance
      .post(
        "/login",
        {
          email: user.email,
          password: user.password,
          is_admin: false,
        },
        {
          headers: {
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }

  logout() {
    return axiosInstance
      .post("/logout", null, {
        headers: authHeader(),
      })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }

  isSessionActive(userLogin) {
    return axiosInstance
      .post("/session_check", userLogin, {
        headers: authHeader(),
      })
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export default new AuthService();
